import { Device } from '@capacitor/device';

export default async function getDeviceData() {
  try {
    const info = await Device.getInfo();
    const deviceId = await Device.getId();
    const languageCode = await Device.getLanguageCode();
    const deviceData = {
      make: info.manufacturer,
      model: info.model,
      build: info.osVersion,
    };

    deviceData.locale = languageCode.value;

    if (info.platform === 'ios') {
      deviceData.ios_idfv = deviceId.identifier;
    } else {
      deviceData.android_asid = deviceId.identifier;
    }

    return deviceData;
  } catch (error) {
      console.error('Failed to get device info', error);
      throw error;
  }
}